
import React from 'react';
import Spinner from './Spinner';

interface LoadingDataIndicatorProps {
  message?: string;
}

const LoadingDataIndicator: React.FC<LoadingDataIndicatorProps> = ({ message = 'đang tải dữ liệu ...' }) => {
  return (
    <div className="flex flex-col items-center justify-center py-4 text-teal-600 pointer-events-none animate-in fade-in duration-500">
      <div className="bg-white/90 backdrop-blur-sm px-6 py-3 rounded-full shadow-lg border border-teal-100 flex items-center gap-3 transition-all duration-300">
        <Spinner size="sm" />
        <span className="text-sm font-semibold text-teal-700 tracking-wide uppercase">{message}</span>
      </div>
    </div>
  );
};

export default LoadingDataIndicator;
